import Record from "./base"

export default class Category extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
